module.exports = __webpack_public_path__ + "img/dark.59429cbb.jpg";